import { PageProps, ModalProps } from "./types";

export const PageContainer = ({ children, title }: PageProps) => {
  return (
    <div className="w-full flex flex-col gap-6 bg-white dark:bg-[#FFFFFF1A] rounded-lg border border-gray-200 p-4 md:p-6">
      <span className="satoshi-xl-bold-pry-900 dark:text-white">{title}</span>
      {children}
    </div>
  );
};

export const ModalContainer = ({ title, children, closeIcon }: ModalProps) => {
  return (
    <div className="fixed z-[70] inset-0 w-screen h-screen bg-black/20 backdrop-blur-md flex items-center justify-center p-2 sm:p-4">
      <div className="w-[95vw] sm:w-full sm:max-w-lg max-h-[90vh] overflow-hidden bg-white dark:bg-[#1E1E1E] rounded-lg border border-gray-200 dark:border-[#FFFFFF1A] p-4 sm:p-6 flex flex-col shadow-xl animate-in fade-in zoom-in-95 duration-150">
        <div className="flex items-center justify-between shrink-0 mb-4">
          <span className="satoshi-xl-bold-pry-900 dark:text-white">
            {title}
          </span>
          {closeIcon && closeIcon}
        </div>
        <div className="overflow-y-auto flex-1 px-1">{children}</div>
      </div>
    </div>
  );
};
